// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1pzhI","savePackageButton":"ClientWallet_savePackageButton__3va7l"};